// leaderboard.jsx // Leaderboard component
import dynamic from 'next/dynamic';

import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import {
  getShowLeaderboardIssueMessageFlag
} from "@/utils/firebaseFunctions";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { Icon } from "@iconify/react";
import clipboardCopy from "clipboard-copy";
import { toast } from "react-toastify";
import Image from "next/image";
import Button from "@/components/ui/Button";

export default function LeaderBoard({
  leaderboard,
  leaderboardLoading,
  leaderboardTabChange,
  leaderboardHandleNext,
  leaderboardHandlePrev,
  user,
  userPoints,
}) {
  // const { user } = useAuth();
  const [tabIndex, setTabIndex] = useState(0);
  const [showLeaderboardIssueMessage, setShowLeaderboardIssueMessage] = useState(false);

  const handleCopyToClipboard = (text) => {
    clipboardCopy(text);
    toast.success("Copied to clipboard!");
  };

  useEffect(() => {
    const checkLeaderboardIssueMessageFlag = async () => {
      const showLeaderboardIssueMessageFlag = await getShowLeaderboardIssueMessageFlag();
      setShowLeaderboardIssueMessage(showLeaderboardIssueMessageFlag);
    };

    checkLeaderboardIssueMessageFlag();
  }, []);

  const TabPanelHeader = () => {
    return (
      <div className="flex flex-row items-stretch justify-start w-full mb-4 pl-2 pr-1">
        <div className="text-white text-sm gothamMedium w-16 flex items-center">
          Rank
        </div>
        <div className="text-white text-sm gothamMedium flex items-center flex-grow">
          UID
        </div>
        <div className="text-white text-sm gothamMedium w-24 flex items-center">
          Points
        </div>
      </div>
    )
  };

  const TabPanelUserPoints = (user, userPoints, activeIndex, leaderboard) => {
    // Use userRankData from new API if available, otherwise fallback to userPoints
    const userRankData = leaderboard?.userRankData;
    const displayUserData = userRankData || userPoints;
    
    return (
      <Fragment>
        {user ? (
          <Fragment>
            {!displayUserData && (
              <div className="flex flex-col items-stretch justify-start w-full mb-4">
                <div className="flex flex-row items-stretch justify-start w-full bg-metaxseed-orange rounded-lg py-1 pl-2 pr-1">
                  <div className="py-1 text-white text-sm gothamMedium w-16 flex items-center">
                    You
                  </div>
                  <div className="py-1 text-white text-sm gothamBook flex items-center flex-grow">
                    ...
                  </div>
                  <div className="py-1 px-2 text-white text-sm gothamMedium rounded-lg w-24 flex items-center bg-metaxseed-content-gray">
                    <Image
                      src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729068489/gold_lr_h4yg2m.png"
                      className="w-6 h-6 mr-2"
                      alt="MXS GOLD"
                      width={200}
                      height={200}
                    />
                    ...
                  </div>
                </div>
              </div>
            )}
            {displayUserData && (
              <div className="flex flex-col items-stretch justify-start w-full mb-4">
                <div className="flex flex-row items-stretch justify-start w-full bg-metaxseed-orange rounded-lg py-1 pl-2 pr-1">
                  <div className="py-1 text-white text-sm gothamMedium w-16 flex items-center">
                    #{userRankData ? userRankData.rank : (activeIndex === 0 ? userPoints?.rank_with_bonuses : activeIndex === 1 ? userPoints?.rank_daily : activeIndex === 2 ? userPoints?.rank_weekly : activeIndex === 3 ? userPoints?.rank_monthly : userPoints?.rank_yearly)}
                  </div>
                  <div className="py-1 text-white text-sm gothamBook flex items-center flex-grow">
                    {(userRankData?.photo_url || user.photo_url) ? (
                      <Image
                        src={userRankData?.photo_url || user.photo_url}
                        className="w-6 h-6 mr-2 rounded-full bg-black-500"
                        alt="User Pfp"
                        width={200}
                        height={200}
                      />
                    ) : (
                      <Image
                        src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                        className="w-6 h-6 mr-2 rounded-full bg-black-500"
                        alt="User Pfp"
                        width={200}
                        height={200}
                      />
                    )}
                    <span>
                      {(userRankData?.uid || userPoints?.uid)?.length > 6
                        ? (userRankData?.uid || userPoints?.uid).substring(0, 3) +
                        "..." +
                        (userRankData?.uid || userPoints?.uid).substring(
                          (userRankData?.uid || userPoints?.uid).length - 3,
                          (userRankData?.uid || userPoints?.uid).length
                        )
                        : (userRankData?.uid || userPoints?.uid)}
                    </span>
                    <button
                      onClick={() =>
                        handleCopyToClipboard(userRankData?.uid || userPoints?.uid)
                      }
                      className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400 ml-2"
                    >
                      <Icon
                        icon="solar:copy-linear"
                        className="text-metaxseed-gray"
                      />
                    </button>
                  </div>
                  <div className="py-1 px-2 text-white text-sm gothamMedium rounded-lg w-24 flex items-center bg-metaxseed-content-gray">
                    <Image
                      src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729068489/gold_lr_h4yg2m.png"
                      className="w-6 h-6 mr-2"
                      alt="MXS GOLD"
                      width={200}
                      height={200}
                    />

                    {userRankData ? userRankData.value : (activeIndex === 0 ? userPoints?.all_time_mxs_gold_with_bonuses : activeIndex === 1 ? userPoints?.daily_mxs_gold : activeIndex === 2 ? userPoints?.weekly_mxs_gold : activeIndex === 3 ? userPoints?.monthly_mxs_gold : userPoints?.yearly_mxs_gold)}
                  </div>
                </div>
              </div>
            )}
          </Fragment>
        ) : null}
      </Fragment>
    )
  };

  const TabPanelBody = (user, leaderboard, activeIndex) => {
    return (
      <Fragment>
        <div className="flex flex-col items-stretch justify-start w-full">
          {leaderboard?.data.map((leaderboardUser, index) => (
            <div
              key={index}
              className="flex flex-row items-stretch justify-start w-full mb-1 bg-metaxseed-dark-gray rounded-lg py-1 pl-2 pr-1"
            >
              <div className="py-1 text-white text-sm gothamMedium w-16 flex items-center">
                #{leaderboardUser.rank_with_bonuses || leaderboardUser.rank_daily || leaderboardUser.rank_weekly || leaderboardUser.rank_monthly || leaderboardUser.rank_yearly || leaderboardUser.rank}
              </div>
              <div className="py-1 text-white text-sm gothamBook flex items-center flex-grow">
                {leaderboardUser.userDetails && leaderboardUser.userDetails.photo_url ? (
                  <Image
                    src={leaderboardUser.userDetails.photo_url}
                    className="w-6 h-6 mr-2 rounded-full bg-black-500"
                    alt="User Pfp"
                    width={200}
                    height={200}
                  />
                ) : (
                  <Image
                    src="https://firebasestorage.googleapis.com/v0/b/prodmxs.appspot.com/o/branding%2Fmxs_games%2Fv1%2Fwhite%2Fpng%2Fmxs_icon_white.png?alt=media&token=8a7e36ba-954b-46b3-bcb2-559cec885bdf"
                    className="w-6 h-6 mr-2 rounded-full bg-black-500"
                    alt="User Pfp"
                    width={200}
                    height={200}
                  />
                )}
                <span>
                  {leaderboardUser.uid.length > 6
                    ? leaderboardUser.uid.substring(0, 3) +
                    "..." +
                    leaderboardUser.uid.substring(
                      leaderboardUser.uid.length - 3,
                      leaderboardUser.uid.length
                    )
                    : leaderboardUser.uid}{" "}
                </span>
                <button
                  onClick={() => handleCopyToClipboard(leaderboardUser?.uid)}
                  className="cursor-pointer text-zinc-400 dark:text-zinc-600 hover:text-zinc-600 dark:hover:text-zinc-400 ml-2"
                >
                  <Icon
                    icon="solar:copy-linear"
                    className="text-metaxseed-gray"
                  />
                </button>
              </div>
              <div className="py-1 px-2 text-white text-sm gothamMedium rounded-lg w-24 flex items-center bg-metaxseed-content-gray">
                <Image
                  src="https://res.cloudinary.com/dot2onqdb/image/upload/v1729068489/gold_lr_h4yg2m.png"
                  className="w-6 h-6 mr-2"
                  alt="MXS GOLD"
                  width={200}
                  height={200}
                />

                {leaderboardUser.all_time_mxs_gold_with_bonuses || leaderboardUser.daily_mxs_gold || leaderboardUser.weekly_mxs_gold || leaderboardUser.monthly_mxs_gold || leaderboardUser.yearly_mxs_gold || leaderboardUser.value}
              </div>
            </div>
          ))}
        </div>
      </Fragment>
    )
  };

  return (
    <Fragment>
      <Fragment>
        <div className="flex flex-col items-start justify-stretch">
          {showLeaderboardIssueMessage && (
            <div className="gothamBook w-full text-xs text-metaxseed-gray text-center">
              <p className="mb-0">Our leaderboards are temporarily experiencing issues.</p>
              <p className="mb-0">The data displayed may be incorrect.</p>
              <p className="mb-0">Unusual points activity is being audited.</p>
              <p className="mb-0">Thank you for your patience.</p>
            </div>
          )}

          <Tabs
            className={"leaderboardTabs flex flex-col flex-grow w-full"}
            selectedIndex={tabIndex}
            disabled={leaderboardLoading || !leaderboard}
            onSelect={(index) => {
              setTabIndex(index);
              leaderboardTabChange(index);
            }}
          >
            <TabList className="flex flex-row items-stretch justify-between w-full mt-4 mb-4">
              <Tab className={"mr-0 p-0 flex flex-grow flex-1"}>
                <button className="gothamMedium text-xl rounded-t-lg text-white bg-metaxseed-blue flex flex-1 items-center justify-center py-1 px-4 mr-1">
                  A
                </button>
              </Tab>
              <Tab className={"mr-0 p-0 flex flex-grow flex-1"}>
                <button className="gothamMedium text-xl rounded-t-lg text-white bg-metaxseed-blue flex flex-1 items-center justify-center py-1 px-4 mr-1">
                  D
                </button>
              </Tab>
              <Tab className={"mr-0 p-0 flex flex-grow flex-1"}>
                <button className="gothamMedium text-xl rounded-t-lg text-white bg-metaxseed-blue flex flex-1 items-center justify-center py-1 px-4 mr-1">
                  W
                </button>
              </Tab>
              <Tab className={"mr-0 p-0 flex flex-grow flex-1"}>
                <button className="gothamMedium text-xl rounded-t-lg text-white bg-metaxseed-blue flex flex-1 items-center justify-center py-1 px-4 mr-1">
                  M
                </button>
              </Tab>
              <Tab className={"mr-0 p-0 flex flex-grow flex-1"}>
                <button className="gothamMedium text-xl rounded-t-lg text-white bg-metaxseed-blue flex flex-1 items-center justify-center py-1 px-4">
                  Y
                </button>
              </Tab>
            </TabList>

            <TabPanel>
              {leaderboardLoading ? (
                <div className="flex items-center justify-center min-h-[576px]">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400"></div>
                </div>
              ) : (
                <Fragment>

                  <TabPanelHeader />

                  {TabPanelUserPoints(user, userPoints, 0, leaderboard)}

                  {TabPanelBody(user, leaderboard, 0)}
                </Fragment>
              )}
            </TabPanel>
            <TabPanel>
              {leaderboardLoading ? (
                <div className="flex items-center justify-center min-h-[576px]">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400"></div>
                </div>
              ) : (
                <Fragment>

                  <TabPanelHeader />

                  {TabPanelUserPoints(user, userPoints, 1, leaderboard)}

                  {TabPanelBody(user, leaderboard, 1)}
                </Fragment>
              )}
            </TabPanel>
            <TabPanel>
              {leaderboardLoading ? (
                <div className="flex items-center justify-center min-h-[576px]">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400"></div>
                </div>
              ) : (
                <Fragment>

                  <TabPanelHeader />

                  {TabPanelUserPoints(user, userPoints, 2, leaderboard)}

                  {TabPanelBody(user, leaderboard, 2)}
                </Fragment>
              )}
            </TabPanel>
            <TabPanel>
              {leaderboardLoading ? (
                <div className="flex items-center justify-center min-h-[576px]">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400"></div>
                </div>
              ) : (
                <Fragment>

                  <TabPanelHeader />

                  {TabPanelUserPoints(user, userPoints, 3, leaderboard)}

                  {TabPanelBody(user, leaderboard, 3)}
                </Fragment>
              )}
            </TabPanel>
            <TabPanel>
              {leaderboardLoading ? (
                <div className="flex items-center justify-center min-h-[576px]">
                  <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400"></div>
                </div>
              ) : (
                <Fragment>

                  <TabPanelHeader />

                  {TabPanelUserPoints(user, userPoints, 4, leaderboard)}

                  {TabPanelBody(user, leaderboard, 4)}
                </Fragment>
              )}
            </TabPanel>
          </Tabs>

          {!leaderboardLoading && leaderboard ? (
            <div className="flex justify-stretch items-stretch w-full mt-4">
              <Button
                className={"gothamMedium text-white rounded-lg py-1 px-4 flex flex-1 justify-center items-center " + (leaderboard.hasPrev ? 'bg-metaxseed-blue ' : 'bg-metaxseed-gray')}
                disabled={leaderboard.hasPrev ? false : true}
                onClick={() => {
                  leaderboardHandlePrev(tabIndex);
                }}
              >
              <Icon icon="ph:caret-left-bold" className="text-xl" />
              </Button>

              <Button
                className={"gothamMedium text-white rounded-lg py-1 px-4 ml-2 flex flex-1 justify-center items-center " + (leaderboard.hasNext ? 'bg-metaxseed-blue ' : 'bg-metaxseed-gray')}
                disabled={leaderboard.hasNext ? false : true}
                onClick={() => {
                  leaderboardHandleNext(tabIndex);
                }}
              >
                <Icon icon="ph:caret-right-bold" className="text-xl" />
              </Button>
            </div>
          ) : null}
        </div>
      </Fragment>
    </Fragment>
  );
}
